import classNames from 'classnames';
import * as React from 'react';
import styles from 'src/components/assets/simple-table.module.scss';
import { ChangeEvent } from 'react';
import { connect } from 'react-redux';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { Dispatch } from 'redux';
import { DateTimePicker } from 'react-widgets';
import { StoreState } from '../../../../../../../../../store/reducers';
import { changeToZeroMoment, changeToZeroZoneDate } from 'src/helpers/timeHelpers';
import Loader from '../../../../../../../../../components/Loader';
import GeneralEnumService from '../../../../../../../../../enumerables/general-enum';

export interface StateProps {
    inProgress: boolean;
}

export interface DispatchProps {
    updateData: (val: any) => Promise<any>;
}

export interface OwnProps {
    columns: { id: string; label: string; type?: string; cellStyle: string }[];
    row: any;
    key: string;
    action: (val: any) => void;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}
export interface State {
    id?: string | number;
    createdAt: Date | undefined;
    info: string;
    userId?: string;
    columnForm?: boolean;
    status: { label: string; value: number };
    bonusType: { label: string; value: number };
}

class FormColumn extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            id: '',
            info: props.row.info ? props.row.info : '',
            status: { label: 'one', value: 1 },
            bonusType: { label: 'one', value: 1 },
            createdAt: props.row.createdAt ? changeToZeroZoneDate(props.row['createdAt']) : undefined,
        };
    }

    handleChange = (event: ChangeEvent<HTMLInputElement>, name: string) => {
        this.setState({ ...this.state, [name]: event.target.value });
    };

    render() {
        const { setOpenDrop, status, bonusType, id, getData } = this.props.row;

        const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('BonusStatus') : {};
        const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
        const valueStatus: any = statusItems.find((it) => it.value === status);
        const valueStatusLabel = valueStatus ? valueStatus.label : '';

        const GeneralEnumType = GeneralEnumService ? GeneralEnumService.getEnum('BonusType') : {};
        const typeItems: SelectObject[] = getValFromEnum(GeneralEnumType);
        const valueType: any = typeItems.find((it) => it.value === bonusType);
        const valueTypeLabel = valueStatus ? valueStatus.label : '';

        const today = new Date();
        const columnChange: any = {
            id: (
                <input
                    type="hidden"
                    className={classNames('form-control', 'input-sm')}
                    onChange={(ev) => this.handleChange(ev, 'id')}
                    value={this.state['id']}
                />
            ),
            createdAt: (
                <div style={{ minWidth: 150, maxWidth: 150 }}>
                    {+valueStatus?.value === +4 ? (
                        changeToZeroMoment(this.props.row?.createdAt, 'MMM D, YYYY')
                    ) : (
                        <DateTimePicker
                            onChange={(date: any) => {
                                this.setState({ ...this.state, createdAt: date });
                            }}
                            disabled={!id ? false : true}
                            value={this.state['createdAt']}
                            time={false}
                            date={true}
                            dropUp
                            onToggle={(isOpen) => {
                                if (isOpen) {
                                    setOpenDrop(true);
                                } else {
                                    setOpenDrop(false);
                                }
                            }}
                            format={'MMM D, YYYY'}
                        />
                    )}
                </div>
            ),
            type: <div>{valueTypeLabel}</div>,
            status: <div>{valueStatusLabel}</div>,
        };

        columnChange.info = (
            <div style={{ minWidth: 215 }}>
                <textarea
                    className={classNames('form-control', 'input-sm')}
                    onChange={(event) => {
                        this.setState({ ...this.state, info: event.target.value });
                    }}
                    maxLength={255}
                    value={this.state.info}
                />
            </div>
        );
        const isMobile = window.innerWidth <= 800;
        if (isMobile) {
            return (
                <div className={classNames(styles.relative)}>
                    {this.props.columns.map(
                        (column: { id: string; label: string; type?: string; cellStyle: string }, key) => (
                            <div
                                style={{ minHeight: 50, fontSize: 14 }}
                                className={
                                    'border-secondary text-center  d-flex justify-content-center align-items-center border border-bottom-1'
                                }
                                key={`td-${key}`}
                            >
                                {columnChange[column.id]}
                            </div>
                        ),
                    )}
                    <div className={classNames(styles.hide)}>{this.props.inProgress ? <Loader /> : ''}</div>
                </div>
            );
        } else {
            return (
                <tr className={classNames(styles.relative)}>
                    {this.props.columns.map(
                        (column: { id: string; label: string; type?: string; cellStyle: string }, key) => (
                            <td key={`td-${key}`} className={classNames(styles[column.cellStyle])}>
                                {columnChange[column.id]}
                            </td>
                        ),
                    )}
                    <td className={classNames(styles.hide)}>{this.props.inProgress ? <Loader /> : ''}</td>
                </tr>
            );
        }
    }
}
function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.seances.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        updateData: async (data: any) => {
            ownProps.row.getData({
                page: 1,
                filters: {
                    'provider.id': ownProps.row.providerId,
                    'createdAt[before]': ownProps.row.month.monthEnd,
                    'createdAt[after]': ownProps.row.month.monthStart,
                },
                itemsPerPage: 9000,
            });
            return;
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FormColumn);
